export const storeDataWithGlobalColor = (storeInfo, globalThemeColor) => {
  if(storeInfo?.theme?.colors?.primary_color) {
    storeInfo.theme.colors.primary_color = globalThemeColor?.color?.themeColor || storeInfo?.theme?.colors?.primary_color || '';
  }
  return storeInfo
}

export const storeDataWithUpdatedTheme = (storeInfo, jsonWidgetThemeComponent) => {
  if (storeInfo?.theme) {
    storeInfo.theme.components =
      jsonWidgetThemeComponent || storeInfo.theme.components || {};
  }

  return storeInfo;
};